<template lang="html">
  <v-dialog
    v-model="dialog"
    persistent
    max-width="1100px"
    transition="dialog-transition"
  >
    <template v-slot:activator="{ on }">
      <v-btn
        color="success"
        dark
        v-on="on"
      >
        Create Branch
      </v-btn>
    </template>

    <material-card
      :offset="10"
      :full-width="true"
      color="green"
      title="Branch"
      text="Create Branch"
      class="mb-0"
    > 
      <v-form 
        v-if="dialog" 
        ref="form"
      >
        <v-container>
          <v-row>
            <v-col 
              cols="12" 
              md="6"
              class="pb-0"
            >
              <v-autocomplete
                v-model="form.companyId"
                v-validate="'required'"
                :error-messages="errors.collect('company_uid')"
                :items="companies"
                data-vv-name="company_uid"
                data-vv-as="company"
                item-text="name"
                item-value="id"
                label="Company"
              />
            </v-col>

            <v-col 
              cols="12" 
              md="6"
              class="pb-0"
            >
              <v-text-field
                v-model="form.branchName"
                v-validate="'required'"
                :error-messages="errors.collect('branch_name')"
                data-vv-name="branch_name"
                data-vv-as="Branch Name"                
                label="Branch Name"
              />
            </v-col>

            <v-col 
              cols="12" 
              md="6"
              class="pb-0"
            >
              <v-autocomplete
                v-model="form.omInchargeId"
                v-validate="'required'"
                :error-messages="errors.collect('om_uid')"
                :items="users"
                data-vv-name="om_uid"
                data-vv-as="OM Incharge"
                item-text="name"
                item-value="user_uid"
                label="OM Incharge (OM)"
              />
            </v-col>

            <v-col 
              cols="12" 
              md="6"
              class="pb-0"
            >
              <v-autocomplete
                v-model="form.userInChargeId"
                v-validate="'required'"
                :error-messages="errors.collect('branch_person_in_charge_uid')"
                :items="users"
                data-vv-name="branch_person_in_charge_uid"
                data-vv-as="Branch Incharge"
                item-text="name"
                item-value="user_uid"
                label="Branch Incharge (BIC)"
              />
            </v-col>
            <v-col 
              cols="12" 
              md="6"
            >
              <v-text-field
                v-model="form.branchLicenseNumber"
                v-validate="'required'"
                :error-messages="errors.collect('branch_license_no')"
                data-vv-name="branch_license_no"
                data-vv-as="Branch License Number"
                label="Branch License Number"
              />
            </v-col>
            <v-col 
              cols="12" 
              md="6"
            >
              <v-text-field
                v-model="form.branchShortcode"
                v-validate="'required'"
                :error-messages="errors.collect('branch_shortcode')"
                data-vv-name="branch_shortcode"
                data-vv-as="Branch Shortcode"
                label="Branch Shortcode"
              />
            </v-col>
            <v-col 
              cols="12" 
              md="6"
            >
              <v-text-field
                v-model="form.branchCode"
                v-validate="'required'"
                :error-messages="errors.collect('branch_code')"
                data-vv-name="branch_code"
                data-vv-as="Branch Code"
                label="Branch Code"
              />
            </v-col>

            <v-col 
              cols="12" 
              md="6"
            >
              <v-text-field
                v-model="form.oldBranchCode"
                label="Old Branch Code"
              />
            </v-col>
            <v-col 
              cols="12" 
              md="6"
              class="pb-0"
            >
              <v-menu
                id="date"
                v-model="dateMenu"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="licenseExpiryDateDisplay"
                    class="datepicker"
                    label="License Expiry Date"
                    prepend-icon="event"
                    readonly
                    v-on="on"
                  />
                </template>
                <v-date-picker                  
                  v-model="form.licenseExpiryDate"                  
                  no-title
                  @input="startmenu = false"
                />
              </v-menu>
            </v-col>

            <v-col 
              cols="12" 
              md="6"
              class="pb-0"
            >
              <v-text-field
                v-model="form.branchContactNumber"
                v-validate="'required'"
                :error-messages="errors.collect('branch_contact_number')"
                data-vv-name="branch_contact_number"
                data-vv-as="Branch Contact Number"
                label="Branch Contact Number"
              />
            </v-col>

            <v-col cols="6">
              <v-text-field
                v-model="form.address_line1"
                v-validate="'required'"
                :error-messages="errors.collect('address_line1')"
                data-vv-name="address_line1"
                data-vv-as="Address 1"
                label="Address 1"
              />
              <v-text-field
                v-model="form.address_line2"
                v-validate="'required'"
                :error-messages="errors.collect('address_line2')"
                data-vv-name="address_line2"
                data-vv-as="Address 2"
                label="Address 2"
              />
              <v-text-field
                v-model="form.address_line3"
                label="Address 3"
              />
              <v-autocomplete
                v-model="form.postcode"
                v-validate="'required'"
                :error-messages="errors.collect('postcode')"
                :items="postcodes"
                data-vv-name="postcode"
                data-vv-as="Postcode"
                item-text="postcode"
                item-value="postcode"
                return-object
                label="Postcode"
                @input="postCodeOnChanged(form.postcode.postcode)"
              />
            </v-col>
            
            <v-col cols="6">
              <GmapMap
                ref="mymap"
                :center="defaultMapCoordinates"
                :zoom="13"
                map-type-id="roadmap"
                style="width: 500px; height: 300px"
                :options="{
                  zoomControl: true,
                  mapTypeControl: false,
                  scaleControl: false,
                  streetViewControl: false,
                  rotateControl: false,
                  fullscreenControl: false,
                  disableDefaultUI: false
                }"
              >
                <GmapMarker
                  :position="marker"
                  :clickable="true"
                  :draggable="true"
                  @dragend="getCoordinates($event.latLng)"
                />
              </GmapMap>
            </v-col>

            <v-col 
              cols="12" 
              md="6"
              class="py-0"
            >
              <v-autocomplete
                v-model="branchCity"
                v-validate="'required'"
                :items="filteredCities"
                :error-messages="errors.collect('branch_city')"
                :disabled="dropdownDisabled"
                item-text="name"
                item-value="id"
                data-vv-name="branch_city" 
                data-vv-as="City" 
                label="Branch City"
                return-object
                @input="cityOnChanged(branchCity.id)"
              />
            </v-col>
            <v-col 
              cols="12" 
              md="6"
              class="py-0"
            >
              <v-autocomplete
                v-model="branchState"
                disabled
                :items="states"
                item-text="name"
                return-object
                label="Branch State"
              />
            </v-col>
    
            <v-col
              cols="12"
              class="py-0"
            >
              <v-textarea
                v-model="form.branchRemarks"
                solo
                name="input-7-4"
                label="Branch Remarks"
              />
            </v-col>

            <v-col
              cols="12"
              md="6"
              class="py-0"
            > 
              <v-text-field
                v-model="form.director_name"
                label="Director Name"
              />
            </v-col>
            <v-col
              cols="12"
              md="6"
              class="py-0"
            > 
              <v-text-field
                v-model="form.director_ic"
                v-mask="mask"
                data-vv-name="director_ic"
                label="Director IC"
              />
            </v-col>
            <v-col 
              cols="12" 
              md="6"
              class="py-0"
            >
              <v-text-field
                v-model="form.chat_id"             
                label="Chat ID (request from TCB)"
              />
            </v-col>

            <v-col
              cols="12"
              class="py-0"
            >
              <v-checkbox
                v-model="form.branchIsActive"
              >
                <template v-slot:label>
                  <div>
                    Active Branch
                  </div>
                </template>
              </v-checkbox>
            </v-col>
          </v-row>
        </v-container>
      </v-form>
      
      <v-card-actions>
        <v-spacer />
        <v-btn
          :disabled="progressing"
          text
          @click="dialog = false"
        >
          Close
        </v-btn>
        <v-btn
          :loading="progressing"
          color="success"          
          @click="submitForm"
        >
          Create
        </v-btn>
      </v-card-actions>
    </material-card>
  </v-dialog>
</template>

<script>
  import axios from 'axios'
  export default {
    $_veeValidate: {
      validator: 'new', 
    },
    data () {
      return {
        dialog: false,
        progressing: false,
        companies: [],
        users: [],
        states: [],
        cities: [],
        postcodes: [],
        dateMenu: false,
        form: {
          userInChargeId: '',
          omInchargeId: '',
          companyId: '',
          branchName: '',
          branchShortcode: '',
          branchCode: '',
          branchContactNumber: '',
          branchLicenseNumber: '',
          address_line1: '',
          address_line2: '',
          address_line3: '',
          postcode: '',
          branchRemarks: '',
          director_name: '',
          director_ic: '',
          branchIsActive: 0,
          oldBranchCode: '',
          licenseExpiryDate: this.$moment().format('YYYY-MM-DD'),
          chat_id: '',
        },
        mask: '######-##-####',
        defaultMapCoordinates: { lat: 1.553110, lng: 110.345032 },
        marker: { lat: 0, lng: 0 },
        longitude: 0,
        latitude: 0,
        branchCity: {},
        branchState: {},
        dropdownDisabled: null,
        cityIds: [],
      }
    },
    computed: {
      filteredCities () {
        return this.cities.filter(city => {
          return this.cityIds.includes(city.id)
        })         
      },
      licenseExpiryDateDisplay () {
        if (this.form.licenseExpiryDate == null) {
          return ''
        }

        return this.$moment(this.form.licenseExpiryDate, 'YYYY/MM/DD').format('D MMM YYYY')
      },
    },
    watch: {
      dialog: function (value) {
        if (value) {
          this.loadData()
          this.$validator.resume()
        }
      },
      branchState: function (value) {
        if (value) {
          this.getCoordinatesFromAddress()
        }
      },
    },
    methods: {
      loadData () {
        Promise.all([
          this.$api.companies().list(),
          this.$api.users().list(),
          this.$api.cities().list(),
          this.$api.states().list(),
          this.$api.postcodes().list(),
        ])
          .then(([companies, users, cities, states, postcodes]) => {
            this.companies = companies.data
            this.users = users.data
            this.cities = cities.data
            this.states = states.data
            this.postcodes = postcodes.data
          })
      },
      postCodeOnChanged (postcodeValue) {
        this.branchCity = null
        this.branchState = null
        var cityID = this.postcodes.filter(p => {
          return p.postcode === postcodeValue
        })  

        this.cityIds = this.cities.filter(city => {
          return cityID.some(city2 => {
            return city2.city_id === city.id
          })
        }).map(city3 => {
          return city3.id
        })

        if (this.cityIds.length > 1) {
          this.dropdownDisabled = false
        } else {
          this.dropdownDisabled = true

          var cityId = this.postcodes.find(postcode => {
            return postcode.postcode === postcodeValue
          }).city_id

          if (cityId) {
            var cityObject = this.cities.find(city => {
              return city.id === cityId
            })
            this.branchCity = cityObject

            if (cityObject) {
              var stateObject = this.states.find(state => {
                return state.id === cityObject.state_id
              })
              this.branchState = stateObject
            }
          }          
        }
      },
      cityOnChanged (cityId) {
        var cityObj = this.cities.find(city => {
          return city.id === cityId
        })

        if (cityObj) {
          var stateObj = this.states.find(state => {
            return state.id === cityObj.state_id
          })
          this.branchState = stateObj
        }
      },
      prepareFormData () {
        let form = this.form

        return {
          company_uid: form.companyId,
          branch_person_in_charge_uid: form.userInChargeId,
          om_uid: form.omInchargeId,
          branch_name: form.branchName,
          branch_shortcode: form.branchShortcode,
          branch_code: form.branchCode,
          old_branch_code: form.oldBranchCode,
          branch_contact_no: form.branchContactNumber,
          branch_license_no: form.branchLicenseNumber,
          branch_license_expiry_date: form.licenseExpiryDate,
          branch_remarks: form.branchRemarks,
          branch_is_active: form.branchIsActive === true ? 1 : 0,
          branch_address: this.constructAddress(),
          address_line_one: this.checkStringHasComma(form.address_line1),
          address_line_two: this.checkStringHasComma(form.address_line2),
          address_line_three: this.checkStringHasComma(form.address_line3),
          postcode: form.postcode.postcode,
          director_name: form.director_name,
          director_ic: form.director_ic,
          branch_city: this.branchCity.name,
          branch_state: this.branchState.code,
          chat_id: form.chat_id,
          longitude: this.longitude,
          latitude: this.latitude,
        }
      },
      setProgressing (value = false) {
        this.progressing = value
      },
      closeDialog () {
        this.dialog = false
      },
      submitForm () {
        this.validateForm().then((result) => {
          if (result) {          
            this.setProgressing(true)

            this.$api.branches().create(this.prepareFormData())
              .then((res) => {
                if (res.status === 201) {
                  this.$refs.form.reset()
                  this.$validator.pause()
                  this.closeDialog()

                  this.$snack({
                    message: 'Branch created',
                  })
                  this.$emit('updated')
                }
              })
              .catch(() => {})
              .then(() => {
                this.setProgressing(false)
              })
          } else {
            this.$scrollToFirstErrorInput()
          }
        })  
      },
      validateForm () {
        return this.$validator.validateAll()
      },
      checkStringHasComma (string) {
        if (string) {
          if (string.charAt(string.length - 1) === ',') {
            return string.substring(0, string.length - 1)
          }
        }
        return string
      },
      getCoordinates (location) {
        this.latitude = location.lat()
        this.longitude = location.lng()
      },
      getCoordinatesFromAddress () {
        let axios2 = axios.create()

        delete axios2.defaults.headers.common['Authorization']
        axios2.post('https://maps.googleapis.com/maps/api/geocode/json?address=' + this.constructAddress() + '&key=AIzaSyAkKNcrjO7LVSERlART5ZwZQCpukTY5UBI')
          .then(res => {
            if (res.data.status === 'OK') {
              res.data.results.map(data => {
                this.latitude = data.geometry.location.lat
                this.longitude = data.geometry.location.lng
                this.marker.lat = this.latitude
                this.marker.lng = this.longitude
                this.defaultMapCoordinates.lat = this.latitude
                this.defaultMapCoordinates.lng = this.longitude
              })
            } else {
              this.$snack({ 
                color: 'error',
                message: 'GPS coordinate not found. Please mark the correct location', 
              })
            }
          })
      },
      constructAddress () {
        return this.checkStringHasComma(this.form.address_line1) + ', ' +
          (this.form.address_line2 ? this.form.address_line2 + ', ' : '') +
          (this.form.address_line3 ? this.form.address_line3 + ', ' : '') + this.form.postcode.postcode + ' ' + this.branchCity.name + ', ' + this.branchState.name
      },
    },
  }
</script>

<style lang="css" scoped>
  ::v-deep .datepicker .v-btn{
      padding:0 !important;
      border-radius: 50%;
  }
</style>
